import {
    FORM_SUBMISSIONS
} from "../../constants/action-types";
const initialState = {
    formSubmissions_get: [],
}

const FormSubmissions = (state = initialState, action) => {
    switch (action.type) { 
        case FORM_SUBMISSIONS.FORM_SUBMISSIONS_GET: {
            return Object.assign({}, state, {
                formSubmissions_get: action.payload
            });
        }      

        default:
            return state
    }

}

export default FormSubmissions